$(function() {
	/* Слайдеры */
	
	$('.sixthWrap').slick({
		arrows: false,
		dots: true,
		speed: 750
	});

	$('.sixthArrow--next').on('click', function(e) {
		e.preventDefault();

		$('.sixthWrap').slick('slickNext');
	});

	$('.sixthArrow--prev').on('click', function(e) {
		e.preventDefault();

		$('.sixthWrap').slick('slickPrev');
	});

  	$('.burger').on('click', function(e) {
		e.preventDefault();

		$('.mobMenu').slideDown();
		$('body').addClass('hidden');
	});

	$('.mobMenu__close').on('click', function(e) {
		e.preventDefault();

		$('.mobMenu').slideUp();
		$('body').removeClass('hidden');
	});

	/* Калькулятор */

	var taxPercent = 0.095;	

	// Проверка на корректность вводных данных
    
    // get product id
    function getProductId() {
        return $('#product-id').val();
    }

	function calcValidate() {
		var typeValue = getProductPrice();
		var volumeValue = parseInt($('input[name="volume"]').val());

		if (typeValue != null && volumeValue >= 1) {
			calc(typeValue, volumeValue);
		} else {
			$('.bannerResult').html('');
		}
	}

	// Функция расчета

	function calc(type, volume) {
		var localDelivery = window.delivery || 300;
        const multiply = calcMultiply(volume);
		var fee = 55;
		var pump = 300;
		var pumpCost = 13;

		var taxValue = $('input[name="no-tax"]').prop('checked');
		var pumpingValue = $('input[name="pumping"]').prop('checked');

		var typeName = $('select[name="type"] option:selected').data('name');

		// Получение цены (с tax или без)
		if (taxValue) {
			var typeCost = type.toFixed(2);			
		} else {
			var typeCost = (type * taxPercent + type).toFixed(2);
		}

		// Получение суммы (цена * количество)
		var typeSum = parseFloat((typeCost * volume).toFixed(2));

		//  Проверка на галочку Pumping

		if (pumpingValue) {
			var totalSum = typeSum + localDelivery * multiply + fee * multiply + pump + pumpCost * volume;

			var resultHtml = `
				<div class="bannerResult__top">
					<p>TOTAL</p>
					<p class="bannerResult__topValue">$<span>`+ totalSum.toFixed(2) +`</span></p>
				</div>

				<p class="bannerResult__title">Approximatly price includes</p>

				<ul class="bannerResultList">
					<li class="bannerResultList__item">
						Environmental fee: $<span>`+ fee +`</span>x` + multiply +
					`</li>
					<li class="bannerResultList__item">
						CONCRETE (`+ typeName +`): $`+ typeCost +`x`+ volume +`
					</li>
					<li class="bannerResultList__item">Cost of Pumping: $`+ pumpCost +`x`+ volume +`</li>
					<li class="bannerResultList__item">PUMP delivery and set up: $`+ pump +`</li>
					<li class="bannerResultList__item">Local Delivery: $`+ localDelivery +`x` + multiply + `</li>
				</ul>
			`;
		} else {
			var totalSum = typeSum + localDelivery * multiply + fee * multiply;

			var resultHtml = `
				<div class="bannerResult__top">
					<p>TOTAL</p>
					<p class="bannerResult__topValue">$<span>`+ totalSum.toFixed(2) +`</span></p>
				</div>

				<p class="bannerResult__title">Approximatly price includes</p>

				<ul class="bannerResultList">
					<li class="bannerResultList__item">
						Environmental fee: $<span>`+ fee +`</span>x` + multiply +
					`</li>
					<li class="bannerResultList__item">
						CONCRETE (`+ typeName +`): $`+ typeCost +`x`+ volume +`
					</li>
					<li class="bannerResultList__item">Local Delivery: $`+ localDelivery +`x` + multiply + `</li>
				</ul>
			`;
		}

		$('.bannerResult').html(resultHtml);
	}

    function calcMultiply(num) {
      if (num === 0) return 1;
        const base = [...Array(100).keys()];
        const numbers = base.map(n => n * 10)
        
        var index = numbers.indexOf(num);
        if (index !== -1) {
          return base[index];
        }
        return Math.floor(num/10) + 1;
    }

    // apply cart
    function applyCart() {
        const productqty = parseInt($('input[name="volume"]').val());
        const productId = $('select[name="type"] option:selected').data('id');

        if (!productId) {
            alert('Please select a concrete type before ordering.');
            return;
        }
        if (!productqty || isNaN(productqty) || productqty < 1) {
            alert('Please enter a valid volume (minimum 1 cubic yard).');
            $('input[name="volume"]').focus();
            return;
        }

        const multiply = calcMultiply(productqty);
        const taxValue = $('input[name="no-tax"]').prop('checked');
		const checkedPumping = $('input[name="pumping"]').prop('checked');

        var data = [
            {
                "id": productId,
                "quantity": productqty
            }
        ];
    
        // pump and delivery setup
        if (checkedPumping) {
            data.push({
              "id": 45311780454686,
              "quantity": 1
            });
    
            // pumping
            data.push({
                "id": 45311780258078,
                "quantity": productqty
            });
        }
      
        // environmental  fee
        data.push({
          "id": 45311780552990,
          "quantity": multiply
        });
    
        // extra charge
    //    const qty_extra = Math.ceil(window.extra);
      
    //     if (qty_extra > 0) {
    //        data.push({
    //          'id': 42564795859110,
    //         'quantity': qty_extra
    //       })
    //     }
      
        window.Shopify.clear((r) => {
            $.post('/cart/add.js', {
                items: data,
                success: function(r) {
                    setTimeout(() => {
                        window.location.href = '/cart';
                    }, 1000);
                }
            });
        });
    }
    
    // calc rate
    function calc_rates(zip, callback) {
        var service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(
          {
            origins: ["Los Angeles, CA 91352, USA"],
        destinations: [`Los Angeles, CA ${zip}, USA`],
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.IMPERIAL,
          }, callback);
        
        function callback(response, status) {
            let value = parseInt(response.rows[0].elements[0].distance.value) / 1609.34;

            console.log('value', value);
    
            // 0-7 300
            // 7-12 350
            // 12-20 400
            // 20-27 450
            // 27-40 500
          
            // new 22.04.22
          
          
            // 0-10 300
            // 10-15 350
            // 15-25 400
            // 25-30 450
            // 30-40 500
            // 40-50 550
    
            if (value <= 10 && value > 0) {
                window.delivery = 300;
            } else if (value <= 15 && value > 10) {
                window.delivery = 350;
            } else if (value <= 25 && value > 15) {
                window.delivery = 400;
            } else if (value <= 30 && value > 25) {
                window.delivery = 450;
            } else if (value <= 40 && value > 30) {
                window.delivery = 500;
            } else if (value <= 100 && value > 40) {
                window.delivery = 550;
            }

            calcValidate()
        }
    }

    function getProductPrice() {
        const value = $('select[name="type"]').val();
        return parseFloat( value.replace( '$', '' ) );
    }
    
    $('#add-to-cart').on('click', applyCart);

	$('select[name="type"]').on('change', function(e) {
		calcValidate();
	});

	$('input[name="volume"]').on('input change', function(e) {
		calcValidate();
	});

	$('input[name="pumping"], input[name="no-tax"]').on('change', function(e) {
		calcValidate();
	});

    // on change zip code
    $("#zipcode").on("change paste keyup", function() {
        if (this.value.length == 5) calc_rates(this.value, calc);
    });
});